module.exports = __webpack_public_path__ + "static/img/bienestar-animal.823898a5.jpeg";